import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.135 12.246c-.252 3.283-.207 6.021.624 7.142.83 1.121 14.175 1.008 15.242 0 1.123-1.065.615-8.693.615-8.693M17 11.5c-7.6 0-11.8-1.98-12.949-2.969 0 0-.14-2.42 1.01-2.477 1.152-.057 13.901-.547 15.052.23.366.26 1.011 2.305-.42 2.362-.835.017-4.819-.128-8.943.604M8.731 5.45l.408-1.09c.204-.506.759-.86 1.371-.86h3.53c.554 0 1.079.278 1.312.734L15.73 5"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M17 11.5c-7.6 0-11.8-1.98-12.949-2.969 0 0-.14-2.42 1.011-2.477s13.9-.547 15.052.23c.365.26 1.01 2.305-.422 2.362-.834.017-4.818-.128-8.942.604"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const BriefcaseIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
